import React from 'react';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

/**
 * Thin @dnd-kit wrapper for vertical sortable lists, replacing react-beautiful-dnd's
 * `<DragDropContext><Droppable>`. Pair with `SortableItem` for the rows.
 *
 * @param {Array<string|number>} items - ordered list of item ids (must match SortableItem `id`s)
 * @param {(event: {active, over}) => void} onDragEnd - dnd-kit drag-end handler
 *   (use `DragNDropHelpers.onDndKitDragEnd` to map it to the old reorder callback)
 */
export default function SortableList({ items, onDragEnd, children }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 1 } }));

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis]}
      onDragEnd={onDragEnd}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  );
}
